import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { SUGGEST_GOLF, SUGGEST_GOLF_ERROR, SUGGEST_GOLF_SUCCESS } from '../../../actions.js';

function* suggestGolf({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/get-suggested-facilities`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
        // version: 'v2',
      },
      params: {
        ...payload?.params,
      },
    });

    if (response.status === 200) {
      yield put({
        type: SUGGEST_GOLF_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUGGEST_GOLF_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUGGEST_GOLF_ERROR, payload: error });
  }
}

export function* watchsuggestGolf() {
  yield takeEvery(SUGGEST_GOLF, suggestGolf);
}

function* suggestGolfSaga() {
  yield all([fork(watchsuggestGolf)]);
}

export default suggestGolfSaga;
